/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-04-21 11:38:05
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-10 15:25:28
 */

import * as request from '@/utils/request'

const baseUrl = `paas/labor_invoice`
export default {
  /**
   * @description 获取开票列表
   * @author YQ
   * @date 2019-01-19
   * @param {*} data
   * @returns
   */
  getLaowuInvoiceList(data) {
    return request.post(`/${baseUrl}/list`, data)
  },
  //导出
  getLaowuInvoicEexport(data) {
    return request.post(`/${baseUrl}/export`, data)
  },
  // 获取税局列表
  laborcompanylist(){
	return request.post(`/${baseUrl}/labor/company/list`, {})
  },
  //开票的时候未选择的订单列表
  laowuTxorderList(data){
	return request.post(`/${baseUrl}/withdraw/order/list`, data)
  },
  //开票的时候未选择的订单列表-新
  laowuTxorderListXin(data){
return request.post(`/${baseUrl}/withdraw/user/list`, data)
  },
  //劳务开票
  laowuCreate(data) {
    return request.post(`/${baseUrl}/create`, data)
  },
  //劳务开票-新
  laowuCreateXin(data) {
    return request.post(`/${baseUrl}/store`, data)
  },
  invoiceManageOrderList(data){
	return request.post(`/${baseUrl}/order/list`, data)
  },
  // 提交
  laowuSubmilt(data){
	return request.post(`/${baseUrl}/submit`, data)
  },
  // 一键下载
  laowuDownload(data){
	return request.post(`/${baseUrl}/download`, data)
  },
  // 获取税源地列表
  getNewCompanyList(){
    return request.get(`/paas/user/new_company_list`)
  }
}